/**
 * TheRealEstates Theme - Main JavaScript Entry Point
 *
 * @package TheRealEstates
 */

// Import styles (Vite handles this)
import '../scss/main.scss';

// Import app
import App from './app/App.js';

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

function init() {
  const app = new App();
  app.init();

  // Make app available globally for debugging
  if (import.meta.env.DEV) {
    window.TREApp = app;
  }
}
